<ng-container [formGroup]="form">
  <ix-input
    formControlName="bot_token"
    [label]="'Bot API Token' | translate"
    [required]="true"
    [tooltip]="helptext.Telegram_bot_token_tooltip | translate"
  ></ix-input>

  <ix-chips
    formControlName="chat_ids"
    [label]="'List of chat IDs' | translate"
    [required]="true"
    [tooltip]="helptext.Telegram_chat_ids_tooltip | translate"
  ></ix-chips>
</ng-container>
